import type { PropsWithChildren, SVGProps as ReactSVGProps } from 'react'

export type SVGIllustrationProps = PropsWithChildren<ReactSVGProps<SVGSVGElement>> & {
  /**
   * Override the viewBox of an illustration if needed, these values are inherited from the original SVG
   *
   * @default undefined
   */
  viewBox?: string | undefined

  /**
   * Override width
   *
   * @default '100%'
   */
  width?: string | number

  /**
   * Override height
   *
   * @default 'auto'
   */
  height?: string | number

  /**
   * Disable illustration
   *
   * @default false
   */
  disabled?: boolean

  /**
   * Give illustrations a specific predefined size
   *
   * @default undefined
   */
  size?: 'XXS' | 'XS' | 'S' | 'M' | 'L' | 'XL'
}

export const BaseIllustration = ({
  children,
  viewBox,
  size,
  width = '100%',
  height = 'auto',
  disabled = false,
  ...props
}: SVGIllustrationProps) => (
  <svg
    focusable="false"
    aria-hidden="true"
    {...props}
    className={[
      'DhlIllustration-root',
      ...(disabled ? ['DhlIllustration-disabled'] : []),
      ...(size ? [`DhlIllustration-${size}`] : []),
    ].join(' ')}
    style={{
      width,
      height,
      ...props.style,
    }}
    viewBox={viewBox}
  >
    {children}
  </svg>
)
